export const messages = {
  en: {
    userIntegral: {
      search: {
        title: 'Search Conditions',
        integralName: 'Account Name',
        integralNamePlaceholder: 'Please enter account name'
      },
      list: {
        title: 'User Points'
      },
      table: {
        id: 'ID',
        name: 'Account Name',
        type: 'Object Type',
        userId: 'User ID',
        phone: 'Phone',
        amount: 'Points'
      },
      type: {
        personal: 'Personal',
        merchant: 'Merchant'
      },
      fetchError: 'Failed to fetch points data'
    }
  },
  zh: {
    userIntegral: {
      search: {
        title: '查询条件',
        integralName: '账户名称',
        integralNamePlaceholder: '请输入账户名称'
      },
      list: {
        title: '用户积分'
      },
      table: {
        id: '编号',
        name: '账户名称',
        type: '对象类型',
        userId: '用户编号',
        phone: '手机号',
        amount: '积分数'
      },
      type: {
        personal: '个人',
        merchant: '商户'
      },
      fetchError: '获取积分数据失败'
    }
  },
  'zh-TW': {
    userIntegral: {
      search: {
        title: '查詢條件',
        integralName: '帳戶名稱',
        integralNamePlaceholder: '請輸入帳戶名稱'
      },
      list: {
        title: '用戶積分'
      },
      table: {
        id: '編號',
        name: '帳戶名稱',
        type: '對象類型',
        userId: '用戶編號',
        phone: '手機號',
        amount: '積分數'
      },
      type: {
        personal: '個人',
        merchant: '商戶'
      },
      fetchError: '獲取積分數據失敗'
    }
  }
}